export default __webpack_public_path__ + "images/UNIAIR.182eac9.png";